class CombinedSearchController {

    constructor(
        CombinedSearchService,
        $location
    ) {
        'ngInject'

        this.CombinedSearchService = CombinedSearchService;
        this.location = $location

    }

    /***
     * When someone selects a choice from the typeahead, it brings them to that items edit screen
     * @param item: the item that was chosen
     * @param model: the item that was chosen
     * @param label: the text that was chosen
     */
    onItemSelect(item, model, label) {

        // client, location/campus, and facility all have the same structure for their url.
        let newPath = 'client-admin/' + item.clientId + '/edit/' + item.path + '/';

        // locations and facilities need a to have the their id appended
        if (item.path != 'client') {
            newPath += item.id + '/';
        }

        this.location.path(newPath);
    }

    /**
     * Builds out the list that's used for the search typeahead
     * @param clients An array of clients
     * @param locations An array of locations
     * @param facilities An array of facilities
     * @returns {Array}
     */
    buildCombinedList(clients, locations, facilities) {

        let clientList = clients.map((client, i) => {
            return {
                'name': client.site_id + ' ' + client.name,
                'group': 'Clients',
                'path': 'client',
                'clientId': client.id,
                // isFirst; used on the UI to display the group name if, when looping,
                // the first item of this type is found.
                'isFirst': i == 0 ? true : false
            };
        });

        let locationList = locations.map((location, i) => {
            return {
                'name': location.site_id + ' - ' + location.client_name + ' - ' + location.name,
                'group': 'Locations',
                'path': 'campus',
                'id': location.id,
                'clientId': location.client,
                'isFirst': i == 0 ? true : false
            };
        });

        let facilityList = facilities.map((facility, i) => {
            return {
                'name': facility.site_id + ' ' + facility.client_name + ' - ' + facility.campus_name + ' - ' + facility.name,
                'group': 'Facilities',
                'path': 'facility',
                'id': facility.id,
                'clientId': facility.client,
                'isFirst': i == 0 ? true : false
            };
        });

        return [...clientList, ...locationList, ...facilityList];
    }

    /***
     * Triggered when a user starts typing into the search bar
     */
    searchForEntries(searchValue) {

        return this.CombinedSearchService.searchById(searchValue)
            .then((successResponse) => {

                return this.buildCombinedList(
                    successResponse.data.clients,
                    successResponse.data.locations,
                    successResponse.data.facilities
                );

            });
    }

}

export default CombinedSearchController;


// WEBPACK FOOTER //
// ./app/components/client-admin/combined-search/combined-search-controller.js